// This file provides type definitions for missing types that are causing TypeScript errors
// IMPORTANT: Do not duplicate generated API agent types here.
// Use AgentDto/AgentRequestDto from the generated apiService instead.
import type { AgentRequestDto, CallEndedReason } from './apiService';

export enum CampaignRunStatusType {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface CampaignWithDetailedInfoDto {
  id: string;
  title: string;
  type: string;
  campaignRun?: {
    status: CampaignRunStatusType;
  };
  callSchedule?: any;
  totalLeads?: number;
  pendingLeadsCount?: number;
  reachedLeadsCount?: number;
  unreachedLeadsCount?: number;
  plannedRecallCount?: number;
  leadList?: any[];
  createdAt: string;
  updatedAt?: string;
}

export interface CampaignCallRequestDto {
  callType: 'web-call' | 'outbound-phone-call';
  agentId: string;
  phoneNumber?: string;
}

export interface RecipientConversationDto {
  id: string;
  status: string;
  lead?: any;
  leadId?: string;
  startedAt?: string;
  answeredAt?: string;
  terminatedAt?: string;
  interactionResult?: string;
  sentiments?: ConversationSentimentDto[];
}

export interface InboundConversationDto {
  id: string;
  status: string;
  sentiments?: ConversationSentimentDto[];
  answeredAt?: string;
  result?: string;
  finishedAt?: string;
  startedAt?: string;
  customer?: any;
}

export interface ConversationSentimentDto {
  sentimentScores?: {
    label: string;
    score: number;
  }[];
}

export interface CampaignDto {
  id: string;
  title: string;
  type: string;
  agents?: AgentRequestDto[];
  campaignRun?: {
    status: CampaignRunStatusType;
  };
  callSchedule?: any;
  retryIntervalInMinutes?: number;
  retryMaxNumber?: number;
  followUpTemplate?: string;
  sendFollowUpMessage?: boolean;
  productDetails?: any;
  leadList?: any[];
  analysisPlan?: {
    prompt?: string;
  };
}

export type CallEndedReasonsType = undefined | CallEndedReason;

export interface InterquartileRangeType {
  iqr: number | null;
}

export interface GenderSettings {
  confidenceThreshold: number;
  durationThreshold: number;
  behaviorTemplate: string;
}

export interface ConflictCampaignReferenceDto {
  id: string;
  name?: string;
  title?: string;
}

export interface ConflictWithCampaignsErrorDto {
  message: string;
  metadata: {
    campaigns: ConflictCampaignReferenceDto[];
  };
}

export interface ConflictAgentReferenceDto {
  id: string;
  name: string;
  companyId: string;
  // null when the agent's company was deleted
  companyName: string | null;
}

// 409 from deleting a voice or transcriber that agents still use
export interface ConflictWithAgentsErrorDto {
  message: string;
  metadata: {
    voiceId?: string;
    transcriberId?: string;
    agents: ConflictAgentReferenceDto[];
  };
}

export const useEditAgentControllerEditAgentMutation = () => {
  return [() => {}, { isLoading: false }] as [() => void, { isLoading: boolean }];
};

export const useGetAgentControllerGetAgentQuery = () => {
  return { data: null, isLoading: false, refetch: () => Promise.resolve({ data: null }) };
};

export const useGetAllCampaignsControllerGetAllCampaignsQuery = () => {
  return { data: null, isLoading: false, refetch: () => Promise.resolve({ data: null }) };
};

export const useDeleteCampaignControllerDeleteCampaignMutation = () => {
  return [() => {}, { isLoading: false }] as [() => void, { isLoading: boolean }];
};

export const useInboundConversationListControllerInboundConversationQuery = () => {
  return { data: null, isLoading: false, refetch: () => Promise.resolve({ data: null }) };
};

export const useGetRecipientConversationListControllerGetCampaignQuery = () => {
  return { data: null, isLoading: false, refetch: () => Promise.resolve({ data: null }) };
};

export const useDeleteLeadListControllerDeleteLeadListMutation = () => {
  return [() => {}, { isLoading: false }] as [() => void, { isLoading: boolean }];
};

export const useCampaignCallControllerCampaignCallMutation = () => {
  return [() => {}, { isLoading: false }] as [() => void, { isLoading: boolean }];
};

export const useGetOutboundTestCallToPhoneInfoControllerGetInfoQuery = () => {
  return { data: null, isLoading: false, refetch: () => Promise.resolve({ data: null }) };
};

// Add or update the import in your apiService.ts file to include these types and hooks
